<div class="grid" *ngIf="!minimal">
  <div class="col md:col-4 md:col-offset-4">
    <div class="text-center p-3 border-round-sm bg-yellow-400 font-bold">
      <p><i class="pi pi-lock" style="font-size: 2rem"></i></p>
      <p class="custom-message">
        You do not have permission to view this, if you require this permission
        please speak to your system administrator.
      </p>
    </div>
  </div>
</div>
<ng-container *ngIf="minimal">
  <i class="pi pi-lock" style="font-size: 2rem"></i>
  No Access
</ng-container>
